type Config = {
  companyName: string,

  // Where the logout button takes the user
  logoutUrl: string,
  colors: {
    primary: string
    primaryHover: string,
    primaryLight: string,
    primaryLighter: string,
    primaryFaint: string,
    primaryMuted: string,
  }
  logoUrl: string,
  loginLogoUrl: string,
  decorativeImageUrl: string,
  faviconUrl: string,

  supportEmail: string,
  supportPhone: string,
  termsUrl: string,
  termsUrl2?: string,
  mailingAddress?: string
  showCompanyLoginByDefault: boolean;
}

const configs: Config[] = [
  {
    companyName: "Motala Energi",
    logoutUrl: "https://motalaenergi.se",

    colors: {
      primary: "#e80059",
      primaryHover: "#d20046",
      primaryLight: "#FFE9EE",
      primaryLighter: "#fff9fa",
      primaryFaint: "#fef5f7",
      primaryMuted: "#f1899c",
    },

    logoUrl: process.env.PUBLIC_URL + "/motalaenergi/logo.png",
    loginLogoUrl: process.env.PUBLIC_URL + "/motalaenergi/logo.png",
    decorativeImageUrl: process.env.PUBLIC_URL + "/motalaenergi/decorative.png",
    faviconUrl: process.env.PUBLIC_URL + "/motalaenergi/favicon.ico",

    supportEmail: "kundservice@motalaenergi.se",
    supportPhone: "0141-75 35 10",
    termsUrl: "https://motalaenergi.se/villkor-b2c/",
    mailingAddress: "Motala Energi AB, Box 154, 246 22 Löddeköpinge",
    showCompanyLoginByDefault: false
  },
  {
    companyName: "Fjällkraft",
    logoutUrl: "https://fjallkraft.se",

    colors: {
      primary: "#3373f4",
      primaryHover: "#5489f5",
      primaryLight: "#e8eafc",
      primaryLighter: "#f9f9ff",
      primaryFaint: "#f5f5fe",
      primaryMuted: "#9dbdff",
    },

    logoUrl: process.env.PUBLIC_URL + "/fjallkraft/logo.png",
    loginLogoUrl: process.env.PUBLIC_URL + "/fjallkraft/logo.png",
    decorativeImageUrl: process.env.PUBLIC_URL + "/fjallkraft/decorative.png",
    faviconUrl: process.env.PUBLIC_URL + "/fjallkraft/favicon.ico",

    supportEmail: "support@fjallkraft.se",
    supportPhone: "010-555 87 73",
    termsUrl: "https://fjallkraft.se/wp-content/uploads/2026/01/fjallkraft-villkor-2026-01-20.pdf",
    showCompanyLoginByDefault: false
  },
  {
    companyName: "Norrlandskraft",
    logoutUrl: "https://www.norrlandskraft.se",

    colors: {
      primary: "#16be4b",
      primaryHover: "#6fff9d",
      primaryLight: "#e9ffe9",
      primaryLighter: "#f9f9ff",
      primaryFaint: "#f5f5fe",
      primaryMuted: "#62b97f",
    },

    logoUrl: process.env.PUBLIC_URL + "/norrlandskraft/logo.png",
    loginLogoUrl: process.env.PUBLIC_URL + "/norrlandskraft/logo.png",
    decorativeImageUrl: process.env.PUBLIC_URL + "/norrlandskraft/decorative.png",
    faviconUrl: process.env.PUBLIC_URL + "/norrlandskraft/favicon.ico",

    supportEmail: "info@norrlandskraft.se",
    supportPhone: "010-544 90 80",
    termsUrl: "https://www.norrlandskraft.se/avtalsvillkor-enskild-firma",
    termsUrl2: "https://www.norrlandskraft.se/avtalsvillkor-foretag",
    showCompanyLoginByDefault: true,
  },
];

export default configs[2];
